module.exports = __webpack_public_path__ + "img/twitter-app.15bdfb59.svg";